export class SessionStorage {

  static saveUrlPdf(base64Pdf: any) {
    const byteArray = new Uint8Array(atob(base64Pdf).split('').map(char => char.charCodeAt(0)));
    const file = new Blob([byteArray], {type: 'application/pdf'});
    const pdfSrc = URL.createObjectURL(file);
    sessionStorage.setItem('srcPdf', JSON.stringify(pdfSrc));
  }

  static saveBase64(base64: any) {
    sessionStorage.setItem('base64Pdf', JSON.stringify(base64));
  }

  static getUrlPdf() {
    const pdfSrc = JSON.parse(sessionStorage.getItem('srcPdf'));
    if (pdfSrc) {
      return pdfSrc;
    }
  }
}
